var processConfig = function () { return import('~/pages/system-manage/process-manage/process-config.vue'); };
export default [
    {
        path: '/process-config/process-config',
        name: 'process-config',
        title: '流程配置',
        component: processConfig
    }
];
